// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fs64mgmOQsml8\\+ {\n  display: inline;\n  border-radius: 3px;\n  background-color: var(--ds-background-accent-gray-subtler, rgba(255, 255, 255, 0.69));\n  padding: 3px 8px;\n  font-size: 11px;\n  font-weight: bold;\n  line-height: 16px;\n  align-items: center;\n  color: var(--ds-text, #172B4D);\n  width: fit-content;\n  width: -moz-fit-content;\n}\n._7IHv7hVz0W6Cfh {\n  background-color: rgba(255, 255, 255, 0.2);\n  color: var(--ds-text-inverse, #FFFFFF);\n}\n._1abFHShzDm5m5c {\n  background-color: rgba(0, 0, 0, 0.1);\n  color: var(--ds-text, #172B4D);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardTemplateBadge": "fs64mgmOQsml8+",
	"transparent": "_7IHv7hVz0W6Cfh",
	"transparentDark": "_1abFHShzDm5m5c"
};
export default ___CSS_LOADER_EXPORT___;
